import { connect } from "react-redux";
import { chevronDown } from "react-icons-kit/fa/chevronDown";
import { chevronUp } from "react-icons-kit/fa/chevronUp";
import Icon from "react-icons-kit";
import React, { Fragment } from "react";
import useToggle from "react-use-toggle";

import * as actions from "../../store/actions";
import { ALL_CLINICS, matchesClinic } from "../../util/clinics";
import AdminAddContactCategory from "../AdminAddContactCategory";
import Button from "../Button";
import ContactListItem from "../ContactListItem";
import List from "../List";
import Modal from "../Modal";

import styles from "./ContactListCategory.module.css";

const ContactListCategory = (props) => {
	const {
		categoryId,
		category,
		verified,
		deleteContactCategory,
		admin,
		clinic,
	} = props;

	const changePriority = (change) => {
		props.setContactCategoryOrder({
			categoryId: categoryId,
			shift: change,
		});
	};

	const [editModal, toggleEdit] = useToggle(false);

	// Every category filters on the same predicate, which reads "All" as no narrowing.
	// A category left without the prop still reads as All via defaultProps.
	const allContacts = props.contacts ? props.contacts : {};

	const visibleContacts =
		category && category.contacts
			? category.contacts.filter((contactId) =>
					matchesClinic(allContacts[contactId], clinic),
			  )
			: false;

	// A category earns its header in read mode only by having something to show: one
	// that was never filled, and one the clinic filter empties out, are both a heading
	// over an empty list. Admin edit mode keeps every header regardless, because that is
	// where an admin reorders, renames and deletes them.
	const isAdminEditMode = verified === "admin" && admin;
	const visibleContactCount = visibleContacts ? visibleContacts.length : 0;
	const hiddenOutsideEditMode = !isAdminEditMode && visibleContactCount === 0;

	const priorityBtnStyleUp = {
		padding: ".1rem .4rem .3rem",
		borderRadius: "3px 0 0 3px",
		height: "1.6rem",
	};

	const priorityBtnStyleDown = {
		padding: ".1rem .4rem .3rem",
		borderRadius: "0 3px 3px 0",
		height: "1.6rem",
	};

	return category && !hiddenOutsideEditMode ? (
		<Fragment>
			<div className={styles.ContactListCategory}>
				<h3 className={styles.CategoryHeader}>
					{category.name}
					{isAdminEditMode ? (
						<div className={styles.Buttons}>
							<div className={styles.PriorityShiftButtons}>
								<Button
									className="gray"
									style={priorityBtnStyleUp}
									onClick={() => changePriority(-1)}
								>
									<Icon size={12} icon={chevronUp} />
								</Button>
								<Button
									className="gray"
									style={priorityBtnStyleDown}
									onClick={() => changePriority(1)}
								>
									<Icon size={12} icon={chevronDown} />
								</Button>
							</div>
							<div className={styles.EditBtn}>
								<Button fontSize="0.8rem" onClick={toggleEdit}>
									Edit Category
								</Button>
							</div>
							<div className={styles.DeleteBtn}>
								<Button
									fontSize="0.8rem"
									onClick={() =>
										deleteContactCategory({
											categoryId: categoryId,
										})
									}
								>
									Delete Category
								</Button>
							</div>
						</div>
					) : null}
				</h3>
				<List className={styles.List}>
					{visibleContacts
						? visibleContacts.map((id) => (
								<ContactListItem
									key={id}
									id={id}
									admin={admin}
								/>
						  ))
						: null}
				</List>
			</div>
			{editModal ? (
				<Modal backdropCloseHandler={toggleEdit} maxWidth="500px">
					<AdminAddContactCategory
						header="Edit Category Name"
						name={category.name}
						categoryId={categoryId}
						submitName="Save"
						submitCallback={toggleEdit}
					/>
				</Modal>
			) : null}
		</Fragment>
	) : null;
};
const mapStateToProps = ({ contacts, auth }, ownProps) => {
	return {
		category: contacts.categories
			? contacts.categories[ownProps.categoryId]
			: false,
		categories: contacts.categories,
		contacts: contacts.contacts,
		verified: auth.verified,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		setContactCategoryOrder: (payload) =>
			dispatch(actions.setContactCategoryOrder(payload)),
		deleteContactCategory: (payload) =>
			dispatch(actions.deleteContactCategory(payload)),
	};
};

ContactListCategory.defaultProps = {
	clinic: ALL_CLINICS,
};

export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(ContactListCategory);
